export default {
  'depth-1': '0 1px 8px 0 rgba(0, 44, 101, 0.1)',
  'depth-2': '0px 2px 8px rgba(0, 44, 101, 0.2)',
};
